import { Component, OnInit, ViewChild, TemplateRef, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { ExecutorSearch } from 'src/app/_models/search-ejecutor-filtro.model';
import { CatalogoModel, BinManagerParams } from 'src/app/_models/bin-catalogos.model';
import { BlockDeleteBin } from 'src/app/_models/block-delete-model';
import { BinesSeachResponse } from 'src/app/_models/bin-seach-result';
import { BinInsumoManager} from 'src/app/_models/bin-insumo-manager';
import { ZeroService } from 'src/app/_services/zero/zero.service';
import { REST_SERVICES } from 'src/app/_services/settings';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { Globals } from 'src/app/_services/zero/globals';
import { MzModalService, MzToastService } from 'ngx-materialize';
import { DatatableComponent } from '../../semantic/datatable/datatable.component';
import { AuthenticationService } from '../../_services/authentification.service';
import { Role } from '../../_models/oauth.models'
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ModalsComponent } from 'src/app/semantic/modals/modals.component';
import { AdquirienteBinManager } from 'src/app/_models/bin-insumo-adquiriente';
import { CamposService } from '../../_services/campos.service';
import { EmisorBinManager } from 'src/app/_models/bin-insumo-emisor';
import { EMPTY } from 'rxjs';
import { procesadores } from 'src/app/_models/formularios/procesadores.model';
import { RequestUpdateBinManager } from 'src/app/_models/request-update-bin-manager.model';

@Component({
  selector: 'app-binmanager',
  templateUrl: './binmanager.component.html',
  styles: [':host {display: block;}'],
  host: ROUTE_ANIMATION_HOST, 
  animations: [ROUTE_ANIMATION],
})
export class BinmanagerComponent implements OnInit {

  public filtros: ExecutorSearch;
  public options: Pickadate.DateOptions
  public tipoBin: Array<CatalogoModel>;
  public accion: Array<CatalogoModel>;
  public estatus: Array<CatalogoModel>;
  public binFiltroParams: BinManagerParams;
  public activo: string = 'false';
  public cellTem: any;
  public rol: Role;
  public blockBin: BlockDeleteBin;
  public datePipe: DatePipe;
  public bin: number;
  public totalAltas: number;
  public totalBajas: number;
  public totalCambios: number;
  public total: number;
  public instituciones: Array<CatalogoModel>;
  public procesadores: Array<procesadores>;
  public universoBinesManager: Array<BinInsumoManager> = [];
  public binesManagerSelected: Array<BinInsumoManager> = [];

  // Datatable componenrtes
  @ViewChild(DatatableComponent) dataTableComp: DatatableComponent;
  public rowsDataTable: Array<BinInsumoManager> = [];
  public columnsDataTable: Array<any> = [];
  public onEventTemplate: EventEmitter<Object>;
  public titleToGroup: string;

  /*
   * Constructor
   */
  constructor(private router: Router,
    private zeroService: ZeroService,
    private route : ActivatedRoute,
    private globals: Globals,
    private authenticationService: AuthenticationService,
    private modalService: MzModalService,
    private toast: ToastrService,
    private obsCampos: CamposService) {
    this.options = globals.optionsByPickerdate;
    this.filtros = new ExecutorSearch();
    this.instituciones = new Array<CatalogoModel>();
    this.universoBinesManager = [];
    this.binesManagerSelected = [];
    this.tipoBin = new Array<CatalogoModel>();
    this.accion = new Array<CatalogoModel>();
    this.estatus = new Array<CatalogoModel>();
    this.binFiltroParams = new BinManagerParams();
    this.blockBin = new BlockDeleteBin();
    this.datePipe = new DatePipe('es-MX');
    this.totalAltas = 0;
    this.totalBajas = 0;
    this.totalCambios = 0;
    this.total = 0;
    this.route.queryParams.subscribe(params => {
    this.bin = params['bin'];
    this.titleToGroup = "BIN: ";
  });
  }

  ngOnInit() {
    this.rol = this.authenticationService.currentUserValue.role;
    this.buscarBin();
    this.validaRol();
    this.consultarProcesadores();
  }

  limpiar() {
    this.filtros = new ExecutorSearch();
    this.rowsDataTable = this.universoBinesManager;
    // Se invoca el metodo actualizaHeaderRol() para que actualice el encabezado y los input check
    // sin agregar otro suscribe
    this.actualizaHeaderRol();
  }

  validaRol() {
    if (Role.Ejecutor == this.rol) {
      this.dataTableComp.onEventTemplate.subscribe(selected => {
        this.validaAccion(selected.rowSelect, selected.targetSelect, selected.accion, selected.grupo);
      });
      this.columnsDataTable = [
        { name: "", cellTemplate: this.dataTableComp.checkTemplateBinManeger, width: 100 },
        { name: "BIN", prop: "bin" },
        { name: "TIPO DE BIN", prop: "tipo", width: 210 },
        { name: "ACCIÓN", prop: "accion", width: 190 },
        { name: "INSTITUCIÓN", prop: "nombreInstitucion", width: 210 },       
        { name: "PROCESADOR", prop: "dscProcesador", width: 210 },
        { name: "OPERACIÓN", cellTemplate: this.dataTableComp.buttomTemplateOptionsBinManeger, width: 230 }
      ];
    }
  }

  validaAccion(rowSelect: any, targetSelect: any, accion: any, grupo: boolean) {
    let scope = this;
    if (accion == "delete") {
      this.validaSuspencionOEliminacion(rowSelect, grupo);
    }
    if (accion == "edit") {
      this.obsCampos.obs.next(EMPTY);
      scope.binFiltroParams.bin = grupo? rowSelect.rango:rowSelect.bin;
      scope.binFiltroParams.idBin = rowSelect.id;
      scope.binFiltroParams.idTipoBin = rowSelect.idTipo;
      scope.binFiltroParams.idInstitucion = rowSelect.idInstitucion;
      scope.binFiltroParams.url = this.router.url;
      scope.binFiltroParams.binManagerAdqiEmisor = rowSelect;
      if(!grupo) {
        scope.binFiltroParams.binManagerAdqiEmisor.grupo = null;
      }
      scope.binFiltroParams.tipoAccion = rowSelect.idAccion;
      scope.binFiltroParams.origenInfo = rowSelect.origenInfo;
      console.log("edit=================>");
      
      this.obsCampos.obs.next(this.binFiltroParams);
      
      if(rowSelect.idAccion == 1 && !grupo) {
        this.router.navigate(['/binesAbc','I'], {
          queryParams: { refresh: new Date().getTime() }
        });
      } else if (rowSelect.idAccion == 3 && !grupo) {
        this.router.navigate(['/binesAbc', rowSelect.id,'I'], {
          queryParams: { refresh: new Date().getTime() }
        });
      } else if(rowSelect.idAccion == 1 && grupo) {
        this.router.navigate(['/binesAbc','G'], {
          queryParams: { refresh: new Date().getTime() }
        });
      } else if (rowSelect.idAccion == 3 && grupo) {
        this.router.navigate(['/binesAbc', rowSelect.id,'G'], {
          queryParams: { refresh: new Date().getTime() }
        });
      }      
    }
    /*if (accion == "revisar") {
      this.router.navigate(['/detalleBinPrev', rowSelect.id, true]);
    }*/
    if (accion == "consultar") {
      let rechazado: boolean;
      rechazado = rowSelect.idEstatus == 4 ? true : false;

      // Datos extra enviasos por route
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'idEstatus' : rowSelect.idEstatus,
          'origen': "BinManager",
          'origenInfo': rowSelect.origenInfo,
          refresh: new Date().getTime()
        }           
      };

      if(!grupo){
        this.router.navigate(
          ["/detalleBin", rowSelect.id, true, rechazado, "I"],
          navigationExtras
        );
      } else if(grupo){
         if(rowSelect != null && rowSelect.binesEnGrupo.length == 1){
          this.router.navigate(["/detalleBin", rowSelect.id, true, rechazado, "I"],
          navigationExtras
        );
        }else{
          this.router.navigate(["/detalleBin", rowSelect.idGrupoBub, true, rechazado, "G"],
          navigationExtras
        );
        }
      }
    }

    if (accion == "comment") {
      this.verComentario(rowSelect.id);
    }
    if (accion == "select") {
      if (targetSelect.checked) {
        rowSelect.isChecked = true;
        scope.binesManagerSelected.push(rowSelect);

      } else {
        rowSelect.isChecked = false;
        let index = scope.binesManagerSelected.findIndex(x => x.bin === rowSelect.bin);
        scope.binesManagerSelected.splice(index, 1);
      }
    }
  }

  verComentario(idBin: number) {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSCAR_COMENTARIO + idBin,
      method: 'GET',
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0" && response.response) {
          this.modalService.open(ModalsComponent, {
            modal_title: "COMENTARIO",
            modal_body: response.response,
            isComents: false
          });
        } else {
          this.toast.warning('<h5>Mensaje de sistema...</h5> <span>No existen comentarios</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
        }
      }
    });
  }

  validaSuspencionOEliminacion(rowSelect: any, grupo: boolean) {
    let mensaje = "";
    let url = "";
    if (rowSelect.idEstatus == 1) {
      mensaje = "¿Está seguro de suspender el registro?";
      url = REST_SERVICES.SUSPENDER_BIN;
      this.modalComentarioEliminar(rowSelect.id, mensaje, url, rowSelect.bin, rowSelect.binesList, grupo);
    } else if (rowSelect.idEstatus == 3 || rowSelect.idEstatus == 4) {
      mensaje = "¿Está seguro de eliminar el registro?";
      url = REST_SERVICES.ELIMINAR_BIN;
      this.modalComentarioEliminar(rowSelect.id, mensaje, url, rowSelect.bin, rowSelect.binesList, grupo);
    } else {
      this.toast.warning('<h5>Mensaje de sistema...</h5> <span>Solo los bines con estatus capturado y rechazado, pueden ser eliminados</span>', "",
        { closeButton: false, enableHtml: true, disableTimeOut: false });
    }
  }

  modalComentarioEliminar(id: number, mensaje: string, url: string, bin: number, binesList: string, grupo: boolean) {
    let modal: any = this.modalService.open(ModalsComponent, {
      modal_title: mensaje,
      modal_body: "",
      isComents: true
    });
    modal.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {
        this.eliminarSuspender(url, id, comentario, bin, binesList, grupo);
      }
    })
  }


  eliminarSuspender(url: string, id: number, comentario: string, bin: number, binesList: string, grupo: boolean) {
    let scope = this;
    if(binesList != null && binesList != undefined && grupo) {
      scope.blockBin.binesList = binesList;
      scope.blockBin.idGrupo = null;
      this.filtros.idGrupo = scope.blockBin.idGrupo;
    }
    scope.blockBin.id = id;
    scope.blockBin.rol = localStorage.getItem('currentRol');
    scope.blockBin.comentarioOpe = comentario;
    scope.blockBin.procedencia = "binmanager";
    scope.zeroService.request({
      isSingleResponse: false,
      uri: url,
      method: 'PUT',
      showInfo: true,
      params: scope.blockBin,
      ok: (response) => {
        this.filtros.bin = bin;
        scope.buscarBin(); 
        if (response.responsecode == "0") {
          this.filtros = new ExecutorSearch();
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });   
        }
      }
    });

  }


  buscarBin() {
    let scope = this;
    if (!this.filtros.bin) {
      this.filtros.bin = null;
    } if (!this.filtros.idAccion) {
      this.filtros.idAccion = null;
    } if (!this.filtros.idBanco) {
      this.filtros.idBanco = null;
    } if (!this.filtros.idEstadoBin) {
      this.filtros.idEstadoBin = null;
    } if (!this.filtros.idTipoBin) {
      this.filtros.idTipoBin = null;
    } if (!this.filtros.fechaInicio) {
      this.filtros.fechaInicio = null;
    } if (!this.filtros.fechaFin) {
      this.filtros.fechaFin = null;
    } if(this.bin) {
      this.filtros.bin = scope.bin;
    }

    scope.universoBinesManager = [];
    scope.rowsDataTable = [];
    this.resetCounters();
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_BIN_MANAGER,
      method: "POST",
      showInfo: true,
      params: scope.filtros,
      ok: (response) => {
        scope.consultarInstituciones();
        scope.rowsDataTable = new Array<BinInsumoManager>();
        if (response.responsecode == "0") {
          scope.universoBinesManager = response.response;
          scope.rowsDataTable = response.response;
          scope.rowsDataTable.forEach(x => {

            if (x.idTipo != 3){
              x.binesList = x.binesEnGrupo.toString();
            }

            if (x.binesEnGrupo != null && x.binesEnGrupo.length == 1) {
              x.rango = x.binesEnGrupo[0].toString();
            } else if(x.binesEnGrupo != null) {
              x.rango = x.binesEnGrupo[0] + '-' + x.binesEnGrupo[x.binesEnGrupo.length-1];
            }
            if(x.actualizado){
              x.accion = '<span class="material-icons blue-text">lens</span>'  +'  '+ x.accion;
            }else{
              x.accion = '<span class="material-icons blue-text small">trip_origin</span>'+'  '+  x.accion;
            }           
            if(x.idAccion == 1 && !x.actualizado) {
              this.totalAltas += 1;
            } else if (x.idAccion == 2 && !x.actualizado ) {
              this.totalBajas += 1;
            } else if (x.idAccion == 3 && !x.actualizado ){
              this.totalCambios += 1;
            }
          });
          this.total = this.totalAltas + this.totalBajas + this.totalCambios;
        }
      }
    });
  }
  resetCounters(){
    this.totalAltas = 0;
    this.totalBajas = 0;
    this.totalCambios = 0;
    this.total = 0;
  }

  validarNumberBin(e:KeyboardEvent, valor:number ){
    if ( e.keyCode < 48 || e.keyCode > 57   || valor &&  valor.toString().length > 5  ){
      return false;
    }
  }

  buscarBinesFiltros() {
    const binFilter = this.filtros.bin ? this.filtros.bin.toString() : null;
    const idBancoFilter = this.filtros.idBanco ? Number(this.filtros.idBanco) : null;
    const idProcesadorFilter = this.filtros.idProcesador ? Number(this.filtros.idProcesador) : null;

    let binesFilter = this.universoBinesManager.filter(function (e) {
      return ((!binFilter || e.bin.indexOf(binFilter) > -1) &&
        (!idBancoFilter || e.idInstitucion === idBancoFilter) && 
        (!idProcesadorFilter || e.idProcesador === idProcesadorFilter));
    });
    this.rowsDataTable = binesFilter;
    // Se invoca el metodo actualizaHeaderRol() para que actualice el encabezado y los input check
    // sin agregar otro suscribe
    this.actualizaHeaderRol();
  }

  actualizaHeaderRol() {
    if (Role.Ejecutor == this.rol) {
      this.columnsDataTable = [
        { name: "", cellTemplate: this.dataTableComp.checkTemplateBinManeger, width: 100 },
        { name: "BIN", prop: "bin" },
        { name: "TIPO DE BIN", prop: "tipo", width: 210 },
        { name: "ACCIÓN", prop: "accion", width: 190 },
        { name: "INSTITUCIÓN", prop: "nombreInstitucion", width: 210 },       
        { name: "PROCESADOR", prop: "dscProcesador", width: 210 },
        { name: "OPERACIÓN", cellTemplate: this.dataTableComp.buttomTemplateOptionsBinManeger, width: 230 },
      ];
    } 
  }

  consultarInstituciones() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_INSTITUCIONES_COMPLETO,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.instituciones = response.response;
        }
      },
    });
  }

  consultarProcesadores() {
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_PROCESADORES,
      method: "GET",
      showInfo: true,
      ok: (response) => {
        this.procesadores = response.response;
      }
    });
  }

//  actualizarBines() {
//    const scope = this;
//    console.log(scope.binesManagerSelected);
    
//    scope.zeroService.request({
//      isSingleResponse: false,
//      uri: REST_SERVICES.ACTUALIZAR_BINES_BIN_MANAGER,
//      method: "PUT",
//      showInfo: true,
//      params: scope.binesManagerSelected,
//      ok: (response) => {
//        if (response.responsecode == "0") {
//          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>'+ response.responseMessage +'</span>', "",
//            { closeButton: false, enableHtml: true, disableTimeOut: false });

//          scope.binesManagerSelected = [];
//          scope.buscarBin();
//        }
//      }
//    });
//  }

	actualizarBines() {
    const scope = this;
   
    // Verifica si hay registros seleccionados
    if (scope.binesManagerSelected.length === 0) {
      // No hay registros seleccionados, muestra un mensaje de error o realiza la lógica necesaria.
      return;
    }
   
    // Verifica si todos los registros seleccionados son de tipo EmiNac
    const todosEmiNac = scope.binesManagerSelected.every(bin => bin.tipo === 'EmiNac');
   
    if (todosEmiNac && scope.binesManagerSelected.length === 1) {
      // Si se cumple la condición (solo un BIN EmiNac seleccionado), muestra un mensaje de error o realiza la lógica necesaria.
      return;
    }
   
    // Si no se cumple ninguna de las condiciones anteriores, procede con la actualización
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.ACTUALIZAR_BINES_BIN_MANAGER,
      method: "PUT",
      showInfo: true,
      params: scope.binesManagerSelected,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
   
          scope.binesManagerSelected = [];
          scope.buscarBin();
        }
      }
    });
	}

  exportarExcel(){
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_BIN_MANAGER,
      method: "POST",
      showInfo: true,
      showLoading: false,
      ok: (response) => {        
        console.log(response);
        this.procesaResponse(response);
      },
    });
  }

  private procesaResponse(response) {
    if (response.response.archivoReporte != null) {
      this.toast.success(
        "<h5>Mensaje de sistema...</h5>El reporte " + `${response.response.nombre}`+", se estará generando y se notificara cuando este disponible para su descarga. <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Error al generar el reporte de bines<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }
}